import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Undo2 } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDay, fmtAt, servicesChanged } from "@/lib/services";
import { BlinkDot } from "@/components/avisos/BlinkDot";

const when = (days, due) => (days > 1 ? `Vence em ${days} dias (${fmtDay(due)})` : days === 1 ? `Vence amanhã (${fmtDay(due)})` : days === 0 ? `Vence HOJE (${fmtDay(due)})` : `Venceu ontem (${fmtDay(due)})`);

const text = (st) => ({
  due: when(st.days, st.cycle_due),
  confirm: "Foi pago mesmo?! Confirme!",
  paid: `Pagamento marcado por ${st.paid?.by} em ${fmtAt(st.paid?.at)} · amanhã pede confirmação`,
  confirmed: `Pago e confirmado por ${st.confirmed?.by} · próximo ${fmtDay(st.next_due)}`,
  late: `Próximo vencimento ${fmtDay(st.next_due)}`,
}[st.state]);

const TONE = { due: "text-orange-300", confirm: "text-orange-300", paid: "text-sky-300", confirmed: "text-emerald-300", late: "text-slate-400" };

export const PayStatus = ({ it, compact }) => {
  const [busy, setBusy] = useState(false);
  const st = it.status;
  if (st.state === "none") return null;
  const act = async (path, ok) => {
    setBusy(true);
    try { await api.post(`/services/${it.id}/${path}`); toast.success(ok); servicesChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || "Falha ao registrar"); }
    setBusy(false);
  };
  const btn = "inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-bold transition-transform hover:-translate-y-0.5 disabled:opacity-50";
  return (
    <div className="flex flex-wrap items-center gap-2">
      {st.alert && <BlinkDot testid={`service-dot-${it.id}`} />}
      <span data-testid={`service-state-${it.id}`} className={`text-xs font-semibold ${TONE[st.state]}`}>{text(st)}</span>
      {st.state === "due" && (
        <button data-testid={`service-pay-${it.id}`} disabled={busy} onClick={() => act("pay", "Pagamento registrado")} className={`${btn} bg-orange-500 text-slate-950`}>
          <CheckCircle2 className="h-3.5 w-3.5" /> Pagamento Efetuado
        </button>)}
      {st.state === "confirm" && (<>
        <button data-testid={`service-confirm-${it.id}`} disabled={busy} onClick={() => act("pay", "Pagamento confirmado")} className={`${btn} bg-orange-500 text-slate-950`}>
          <CheckCircle2 className="h-3.5 w-3.5" /> Sim, foi pago
        </button>
        <button data-testid={`service-unpay-${it.id}`} disabled={busy} onClick={() => act("unpay", "Marcado como não pago: o alerta volta")} className={`${btn} border border-red-500/40 text-red-300`}>
          <Undo2 className="h-3.5 w-3.5" /> Não foi pago
        </button></>)}
      {st.state === "late" && !compact && st.days >= -5 && (
        <span className="text-[11px] text-slate-500">· pagamento de {fmtDay(st.cycle_due)} não registrado
          <button data-testid={`service-late-pay-${it.id}`} disabled={busy} onClick={() => act("pay", "Pagamento registrado")} className="ml-1 underline hover:text-slate-300">registrar</button>
        </span>)}
    </div>
  );
};
